import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../common/customHttp.service';
import { ApiUrl } from '../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../layout/layout.component';
import { UnitsModel, PageResultDto, UnitsSearchFields } from '../../common/viewModels/GlobalRegistry/UnitsModel';
import { PageEvent } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { PagerService } from '../../common/pagerService';


declare var $: any;
@Component({
  selector: 'units',
  templateUrl: './units.component.html',
  styleUrls: ['./units.component.scss']
})
export class UnitsComponent implements OnInit {
  unitForm: FormGroup;
  unitSearchForm: FormGroup;
  id: number;
  unitId: number;
  UnitsDto: UnitsModel;
  searchFields: UnitsSearchFields = new UnitsSearchFields();
  isNoRecords: boolean = true;
  isSubmitted: boolean = false;
  pager: any = {};
  pagedItems: any[];
  pageResult: PageResultDto;
  length: number = 0;
  pageEvent: PageEvent;
  mainComponent: any;
  //pager:Pager=new Pager();
  $element: any;
  $content: any;
  pageSize: number = 10;

  constructor(public _router: Router, private _formBuilder: FormBuilder, private _pagerService: PagerService,
    private _http: CustomHttp,
    private _appUrl: ApiUrl, private _route: ActivatedRoute,
    private _mApp: MainAppComponent, private _toastrService: ToastrService) {
    this.mainComponent = _mApp;
  }

  ngOnInit() {
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
    this.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
    this.pager.pageSize = this.pageSize;
    this.pager.pageIndex = 0;
    this.pager.pageSizeOptions = this._pagerService.pageSizeOptions;
    this.CreateForm();
    this.unitSearchForm = this._formBuilder.group({
      Name: [''],
      UnitId: [0],
    });
    this.BindStaticSearchData();
    this.setPage(this.pager);
    //this.unitForm.controls['Name'].setValidators(Validators.required);
  }

  CreateForm() {
    this.unitForm = this._formBuilder.group({
      UnitId: [0],
      Name: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(50)])],
    });
  }

  BindStaticSearchData() {
    this.searchFields.PageNo = 0;
    this.searchFields.PageSize = this._pagerService.pageSize;
  }

  setPage(page: any) {
    this.pager.pageSize = page.pageSize;
    this.pager.pageIndex = page.pageIndex;
    this.GetUnitsList(this.pager);
  }

  GetUnitsList(page: any) {
    this.searchFields.PageNo = page.pageIndex;
    this.searchFields.PageSize = page.pageSize
    this._mApp.ShowLoader();
    this._http.post(this._appUrl.GetUnits, this.searchFields)
      .subscribe(
      res => {
        var data = res.json();
        this.length = data.PageResult.TotalRecords;
        this.pagedItems = data.Result;
        this.isNoRecords = !(data.Result.length > 0);
        this._mApp.HideLoader();
      },
      error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      );
  }

  GetUnitsById(id: number) {
    this._mApp.ShowLoader();
    this.unitId = id;
    this._http.get(this._appUrl.GetUnitById + id)
      .subscribe(
      m => {
        this._mApp.HideLoader();
        if (m.json().Result != null) {
          this.unitForm.setValue(m.json().Result);
        }
      }, error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      )
  }

  DeleteUnit(id: any) {
    this.id = id;
  }

  DeleteUnitsById(id: number) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.DeleteUnit + id)
      .subscribe(
      res => {
        this._mApp.HideLoader();
        this.setPage(this.pager);
        this._toastrService.success(res.json().Result, '');

      },
      error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      );
  }

  onSearchSubmit() {
    this.pager.pageIndex = 0;
    let searchDto = this.unitSearchForm.value;
    if (searchDto.Name != null)
      this.searchFields.Name = searchDto.Name;
    this.setPage(this.pager);
  }

  onSubmit() {
    this.unitForm.get('Name').setValidators(Validators.compose([ Validators.required, Validators.minLength(1), Validators.maxLength(50)]));
    this.unitForm.get('Name').updateValueAndValidity();
    this.isSubmitted = true;
    if (this.unitForm.valid) {
      let unitsDto = this.unitForm.value;
      this._mApp.ShowLoader();
      if(unitsDto.UnitId==null||unitsDto.UnitId==0)
      {
        unitsDto.UnitId=0;
      }
      this._http.post(this._appUrl.addUnit, unitsDto)
        .subscribe(
        data => {
          this._mApp.HideLoader();
          this._toastrService.success(data.json().Result, '');
          $('#addUnitModel').modal('toggle');
          this.Clear();
          this.setPage(this.pager);
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
        );
    }
    else {
      //$('#unitName').addClass("mat-input-invalid");
    }
  }

  Clear() {
    this.unitForm.get('Name').setValidators(Validators.compose([ Validators.minLength(1), Validators.maxLength(50)]));
    this.unitForm.get('Name').updateValueAndValidity();
    this.unitForm.reset();        
    //this.CreateForm();
    //this.RemoveInvalidCSS();
  } 

  OnReset() {
    this.unitSearchForm.reset();
    this.pager.pageSize = this._mApp.pageSize;
    this.pager.pageIndex = 0;
    this.searchFields.Name = '';
    this.setPage(this.pager);
  }
  
}
